var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMediaCollection = function SvgIcMediaCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.44 2.67 3.13 5a.2.2 0 0 0-.13.19v13.72a.18.18 0 0 0 .13.18l6.39 2.24a.2.2 0 0 0 .248-.096.2.2 0 0 0 .022-.094L9.71 2.86a.2.2 0 0 0-.27-.19",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 5.05v14M17 5.05v14M21 5.05v14"
  })));
};
export default SvgIcMediaCollection;